export const ButtonHeights = {
  carouselNav: 30,
  default: 44,
  extended: 52,
  large: 64,
  small: 28,
  tag: 36,
};
